export { default, SimpleTag, RemovableTag } from './tag';
export type { RemovableTagProps, SimpleTagProps } from './tag';

export type { AppearanceType, MigrationFallback, TagColor } from './types';

// Export new visual refresh components
export { AvatarTag, TagDropdownTrigger } from './tag-new';
export type {
	AvatarTagProps,
	AvatarRenderProps,
	TypesOfAvatars,
	NewTagColor,
	TagNewProps,
	TagDropdownTriggerProps,
} from './tag-new';
